// Required-but-empty entry fields (new-row payee + amount) use the indigo
// `interactive` accent for their outline, NOT the error/rose color (#1210). An
// empty required field is a prompt to fill it in, not a "bad"/negative state -
// so it reads as the same accent as the focus ring, never as an error. Genuine
// validation errors (e.g. a duplicate payee name) still use the MUI `error`
// (rose) treatment.
//
// Theme-native: reads `theme.palette.interactive` (DESIGN_SYSTEM custom slot).
export const requiredOutlineSx = (theme) => ({
  '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.interactive },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.interactive },
});
